import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { DataGrid, LinkColumn, Tabs } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useRocInternalPortalStore } from 'apps/roc-internal-portal/src/app/hooks';
import {
  techQueueColumns,
  AutomationTechDashboardTab,
  DEFAULT_SORT_MODEL,
} from '../utils';

const useStyles = makeStyles(() => ({
  grid: {
    height: '70vh',
  },
}));

const TABS = [
  {
    value: AutomationTechDashboardTab.TECH_QUEUE,
    label: 'Tech Queue',
  },
  {
    value: AutomationTechDashboardTab.NON_TECH_QUEUE,
    label: 'Non Tech Queue',
  },
];

export const AutomationTechDashboard = observer(() => {
  const classes = useStyles();
  const { automationTechDashboardStore } = useRocInternalPortalStore();
  const { techQueueGridStore } = automationTechDashboardStore;

  useEffect(() => {
    // reset() clears sortModel, so the delay-desc default is re-seeded per tab.
    // setSortModel fetches, so this stays a single request.
    techQueueGridStore.reset();
    techQueueGridStore.setSortModel(DEFAULT_SORT_MODEL);
  }, [automationTechDashboardStore.selectedTab]);

  const onSortChanged = params => {
    const sortModel = params.api.getSortModel();
    techQueueGridStore.setSortModel(sortModel);
  };

  const onFilterChanged = params => {
    const filterModel = params.api.getFilterModel();
    techQueueGridStore.setFilterModel(filterModel);
  };

  const frameworkComponents = {
    loanIdCellRenderer: params => (
      <LinkColumn
        value={params.value}
        url={{ pathname: '/loan_information/' + params.value }}
        onClick={e => {
          open('/nportal/#/loan_information/' + params.value);
          e.preventDefault();
        }}
      />
    ),
  };

  return (
    <Layout title="Automation Tech Dashboard">
      <Grid container>
        <Grid item xs={12}>
          <Tabs
            selectedTab={automationTechDashboardStore.selectedTab}
            tabs={TABS}
            onTabChange={(e, i) => automationTechDashboardStore.setSelectedTab(i)}
          />
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            className={classes.grid}
            columns={techQueueColumns}
            rows={techQueueGridStore.gridData.data.rows}
            frameworkComponents={frameworkComponents}
            key={automationTechDashboardStore.selectedTab}
            onSortChanged={onSortChanged}
            onFilterChanged={onFilterChanged}
            sortModel={techQueueGridStore.sortModel}
            isLoading={techQueueGridStore.isLoading}
            showFilters
            showPagination
            paginationData={techQueueGridStore.gridData.meta}
            setPageNumber={techQueueGridStore.setPageNumber}
          />
        </Grid>
      </Grid>
    </Layout>
  );
});
